<div class="modal fade" id="dialogPessoa" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
  aria-labelledby="Pessoa" aria-hidden="true" *ngIf="entity">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white" style="height: 60px">
        <h5 class="modal-title mt-0 pt-0" id="title">Cadastro de pessoa</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #f="ngForm" id="form_register2" novalidate="">
        <input [(ngModel)]="entity.id" type="text" ngModel name="id" id="id" style="display: none" />
        <div class="modal-body mb-1 pb-1">
          <div class="form-group row">
            <div class="col">
              <select #tipo_ [(ngModel)]="entity.especie" type="text" ngModel name="especie"
                class="custom-select custom-select-sm">
                <option [value]="item.id" *ngFor="let item of listaTipos">
                  {{item.nome}}
                </option>
              </select>
            </div>
            <div class="col">
              <input *ngIf="entity.especie === '1' || entity.especie === '2'"
                [imask]="{mask: [ {mask: '000.000.000-00'}, {mask: '00.000.000/0000-00'} ]}" unmask="true"
                name="cpf_cnpj" [(ngModel)]="entity.cpf_cnpj" type="text"
                class="form-control form-control-sm font-weight-bold" (blur)="buscar()" placeholder="CPF" />
              <input *ngIf="entity.especie !== '1' && entity.especie !== '2'" [(ngModel)]="entity.cpf_cnpj" type="text"
                placeholder="CNPJ" ngModel name="cnpj" id="cnpj" class="form-control form-control-sm font-weight-bold"
                (blur)="buscar()" />
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-6">
              <input [(ngModel)]="entity.nome" type="text" ngModel name="nome" id="nome"
                class="form-control form-control-sm font-weight-bold" placeholder="Nome" />
            </div>
            <div class="col-md-3">
              <input [(ngModel)]="entity.telefone"
                [imask]="{mask: [  {mask: '(00) 0000-0000'}, {mask: '(00) 00000-0000'} ]}" unmask="true" type="text"
                ngModel name="telefone" class="form-control form-control-sm" placeholder="Telefone" />
            </div>
            <div class="col-md-3">
              <input [(ngModel)]="entity.celular"
                [imask]="{mask: [  {mask: '(00) 0000-0000'}, {mask: '(00) 00000-0000'} ]}" unmask="true" type="text"
                ngModel name="celular" class="form-control form-control-sm" placeholder="Celular" />
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-6">
              <input [(ngModel)]="entity.email" type="text" ngModel name="email" id="email"
                class="form-control form-control-sm font-weight-bold" placeholder="E-mail pessoal" />
            </div>
            <div class="col-md-6">
              <input [(ngModel)]="entity.email_profissional" type="text" ngModel name="email_profissional"
                id="email_profissional" class="form-control form-control-sm" placeholder="E-mail profissional" />
            </div>
          </div>

          <hr>
          <div class="form-group row">
            <div class="col">
              <p-inputMask id="cep" [(ngModel)]="entity.cep" type="text" ngModel name=cep mask="99.999-999" slotChar=" "
                styleClass="form-control form-control-sm" [placeholder]="'CEP'" (onBlur)="buscarCEP()" unmask="true">
              </p-inputMask>
            </div>
            <div class="col">
              <input [(ngModel)]="entity.municipio" type="text" ngModel name="municipio"
                class="form-control form-control-sm font-weight-bold" placeholder="Cidade" />
            </div>
          </div>

          <div class="form-group row">
            <div class="col">
              <input [(ngModel)]="entity.endereco" type="text" ngModel name="endereco"
                class="form-control form-control-sm font-weight-bold" placeholder="Endereço" />
            </div>
            <div class="col">
              <input [(ngModel)]="entity.numero" type="text" ngModel name="numero"
                class="form-control form-control-sm font-weight-bold" placeholder="Número" />
            </div>
          </div>

          <div class="form-group row">
            <div class="col">
              <input [(ngModel)]="entity.complemento" type="text" ngModel name="complemnto"
                class="form-control form-control-sm" placeholder="Complemento" />
            </div>
            <div class="col">
              <input [(ngModel)]="entity.bairro" type="text" ngModel name="bairro"
                class="form-control form-control-sm font-weight-bold" placeholder="Bairro" />
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button (click)="salvar()" type="button" class="btn btn-sm btn-primary" id="btnImp">Salvar</button>
          <button (click)="limparDados()" type="button" class="btn btn-sm btn-link">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</div>